import { DefaultUploadSchemaSetting } from './DefaultUploadSchemaSetting';

export default DefaultUploadSchemaSetting;
